import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
const DEFAULT_DPI = 200; // higher is smaller file size b/c more DPI = smaller image dimensions
const MM_PER_INCH = 25.4;
const PIXELS_PER_MM = DEFAULT_DPI / MM_PER_INCH;
const CERTIFICATE_CANVAS_SCALE = 1.5;
const JPEG_QUALITY = 0.85;
export const generatePDF = async (certificateRef, fileName) => {
    if (!certificateRef.current) {
        return;
    }
    try {
        const element = certificateRef.current;
        const canvas = await html2canvas(element, {
            scale: CERTIFICATE_CANVAS_SCALE,
            useCORS: true,
            logging: false,
            backgroundColor: 'white',
            width: element.offsetWidth,
            height: element.offsetHeight,
        });
        const imgWidth = canvas.width / PIXELS_PER_MM;
        const imgHeight = canvas.height / PIXELS_PER_MM;
        const pdf = new jsPDF({
            orientation: imgWidth > imgHeight ? 'landscape' : 'portrait',
            unit: 'mm',
            format: [imgWidth, imgHeight],
            compress: true,
        });
        const imgData = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
        pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);
        pdf.setDisplayMode('fullpage', 'continuous', 'FullScreen');
        pdf.save(`${fileName}.pdf`);
    }
    catch (error) {
        console.error('Error generating certificate of completion PDF:', error);
    }
};
